import PropTypes from "prop-types";

const FunnelMassDateButton = ({ onClick, count, label = "Renovar Massivo" }) => (
  <button
    type="button"
    onClick={onClick}
    className="button"
    style={{ backgroundColor: "#0DB14B", color: "#fff", borderColor: "#0DB14B" }}
  >
    {label}{count ? ` (${count})` : ""}
  </button>
);

FunnelMassDateButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  count: PropTypes.number,
  label: PropTypes.string,
};

export default FunnelMassDateButton;
